import ValueFilter from './ValueFilter';

export type StatusRangeType = 'CYCLE_TIME' | 'LEAD_TIME' | 'CUSTOM';

export interface StatusRangeFilterValue {
  type?: StatusRangeType;
  start?: string;
  end?: string;
}

class StatusRangeFilter extends ValueFilter<StatusRangeFilterValue> {
  toBookmarkConfiguration() {
    return this.getValue();
  }

  set(value: StatusRangeFilterValue) {
    super.set(value ?? {});
  }

  get type() {
    const value = this.getValue();
    return value.type;
  }

  get start() {
    const value = this.getValue();
    return value.start;
  }

  get end() {
    const value = this.getValue();
    return value.end;
  }
}

export default StatusRangeFilter;
